import { Component } from 'react'
import { ResourceType } from '@ds-frontend/resource'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'

import SchoolPageView from './SchoolPageView'
import { Loading } from 'common/widgets'
import classNames from './styles.module.scss'


const propTypes = {
  schoolNewServices: ResourceType.isRequired,
  router: PropTypes.object.isRequired,
}
export default class SchoolPageContainer extends Component {
  componentDidMount() {
    this.props.router.prefetch(`/${this.props.router.locale}/school-finder`)
  }

  componentWillUnmount() {
    this.props.schoolNewServices.clear()
  }

  render() {
    const { schoolNewServices } = this.props
    if(isEmpty(schoolNewServices.data)) {
      return <div className={classNames.loadingWrapper}><Loading isLoading fontSize={48} /></div>
    }
    return (
      <SchoolPageView
        {...this.props}
      />
    )
  }
}

SchoolPageContainer.propTypes = propTypes
